(() => {
  const applyBCGiftHealthPricePatch = () => {
    document.querySelectorAll('product-price').forEach((priceEl) => {
      const card = priceEl.closest('product-card, li, [role="listitem"], .grid__item');
      if (!card) return;

      const packageLink = card.querySelector('a[href*="/products/package-"]');
      if (!packageLink) return;

      const priceNode = priceEl.querySelector('.price');
      if (!priceNode) return;

      priceNode.textContent = '$5,000.00';
      priceNode.classList.remove('price--contact');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBCGiftHealthPricePatch);
  } else {
    applyBCGiftHealthPricePatch();
  }

  setTimeout(applyBCGiftHealthPricePatch, 300);
  setTimeout(applyBCGiftHealthPricePatch, 1200);
  setTimeout(applyBCGiftHealthPricePatch, 2500);
})();
